import comp from "./ColumnTooltip";
export default comp;
